import ResourcePage from "./ResourcePage";

const FIELDS = [
  { name: "title", label: "Title", type: "text" },
  { name: "slug", label: "Slug (url: /collections/slug)", type: "text" },
  { name: "year", label: "Year", type: "text" },
  { name: "concept", label: "One-line concept", type: "text" },
  { name: "description", label: "Concept statement", type: "textarea" },
  { name: "mood", label: "Mood", type: "text" },
  { name: "materials", label: "Materials", type: "list" },
  { name: "techniques", label: "Craft techniques", type: "list" },
  { name: "cultural_references", label: "Cultural references", type: "textarea" },
  { name: "hero_image", label: "Hero image URL", type: "image" },
  { name: "images", label: "Lookbook image URLs", type: "list" },
  { name: "order", label: "Display order", type: "number" },
  { name: "published", label: "Published", type: "checkbox" },
];

export default function CollectionsAdmin() {
  return (
    <ResourcePage
      title="Collections"
      subtitle="Exhibition chapters of the label — LAAL, MATI, NODI, KATHA and beyond."
      endpoint="/collections"
      fields={FIELDS}
      testid="collections"
    />
  );
}
